import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SectionService } from './services/section.service';
import { DateUtilService } from './services/date-util.service';
import { AppTitleService } from './services/title.service';
import { FilterService } from './services/filter.service';
import { UserCacheService } from './services/user-cache.service';
import { FormHelperService } from './services/form-helper.service';
import { DropdownCacheService } from './services/dropdown-cache.service';
import { AdvancedFilterComponent } from './components/advanced-filter/advanced-filter.component';
import { HistoryTabComponent } from './components/history-tab/history-tab.component';
import { DocumentsTabComponent } from './components/documents-tab/documents-tab.component';
import { LinksTabComponent } from './components/links-tab/links-tab.component';
import { ThemeSharedModule } from '@abp/ng.theme.shared';

/**
 * Shared module that provides services and components that can be used across the application
 */
@NgModule({
  declarations: [
    AdvancedFilterComponent,
    HistoryTabComponent,
    DocumentsTabComponent,
    LinksTabComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeSharedModule
  ],
  exports: [
    AdvancedFilterComponent,
    HistoryTabComponent,
    DocumentsTabComponent,
    LinksTabComponent
  ],
  providers: [
    SectionService,
    DateUtilService,
    AppTitleService,
    FilterService,
    UserCacheService,
    FormHelperService,
    DropdownCacheService,
    DatePipe
  ]
})
export class SharedModule { }
